import { metaAdsEndpoint, tiktokAdsEndpoint } from '@/config/endpoints';
import { RPostHogDebounce, posthogUTM } from '@/posthog';
import { getCookie } from '@/utils/getCookie';
import { getFbpFbcFromCookie } from '@/utils/getInfoFromCookie';
import { getAuth } from 'firebase/auth';
import { app } from '@/config/firebaseConfig';
import { StripeModalReportInfo } from '@/zustand/slice/stripeModal';

const { utm } = posthogUTM();

const tiktok_conversion = async (
  email: string,
  value: any,
  transaction_id: string
) => {
  const auth = getAuth();
  await auth.authStateReady();
  const currentUser = auth.currentUser;
  if (!currentUser) {
    console.error('User not authenticated');
    return;
  }
  const authToken = await currentUser.getIdToken();
  await fetch(tiktokAdsEndpoint, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
      Ttclid: new URLSearchParams(window.location.search).get('ttclid') || '',
      Ttp: getCookie('_ttp'),
    },
    body: JSON.stringify({
      type: 'CompletePayment',
      email: email,
      conversion_value: value,
      currency: 'USD',
      transaction_id: transaction_id,
    }),
  });
};

const meta_conversion = async (
  email: string,
  value: any,
  transaction_id: string
) => {
  const auth = getAuth();
  await auth.authStateReady();
  const currentUser = auth.currentUser;
  if (!currentUser) {
    console.error('User not authenticated');
    return;
  }
  const authToken = await currentUser.getIdToken();
  await fetch(metaAdsEndpoint, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
      ...getFbpFbcFromCookie(),
    },
    body: JSON.stringify({
      type: 'CompletePayment',
      email: email,
      conversion_value: value,
      currency: 'USD',
      transaction_id: transaction_id,
    }),
  });
};

export const reportPaymentSuccess = async (
  reportPaymentSuccessInfo: StripeModalReportInfo
) => {
  const auth = getAuth(app);
  await auth.authStateReady();

  const {
    module = 'unknown',
    product_name = 'not_get_product_name',
    amount = 'not_get_amount',
    transaction_id = 'not_get_transaction_id',
    user_id = 'not_get_user',
    email = 'not_get_email',
  } = reportPaymentSuccessInfo;

  const reportData = {
    user_id,
    email,
    user_identity: 3,
    product_name,
    pay_from_module: module,
    ...utm,
  };

  // 此处会多次更新reportData，所以需要防抖上报posthog
  if (module === 'id_photo') {
    RPostHogDebounce('price_success_ai_headshots', reportData);
  } else {
    RPostHogDebounce('price_success', reportData);
  }

  // gtag上报
  if (email) {
    window?.gtag('set', 'user_data', { email });
    window?.gtag('event', 'conversion', {
      send_to: 'AW-16743758761/Z-A5COW77YEaEKn3hbA-',
      value: amount,
      currency: 'USD',
      transaction_id: transaction_id,
    });
    // meta conversion
    meta_conversion(email, amount, transaction_id).then((r) => {});
    // tiktok conversion
    tiktok_conversion(email, amount, transaction_id).then((r) => {});
  }
};
